export default {
  loadingScreenLabel: {
    id: 'bo_sellers_customer_care_all_requests_loading_label',
    defaultMessage: "Let's see what's in store for today...",
  },
  paginationLabel: {
    id: 'bo_sellers_customer_care_pagination_aria_label',
    defaultMessage: 'Navigate to page {page}',
  },
  navigationLabel: {
    id: 'bo_sellers_customer_care_pagination_navigation_aria_label',
    defaultMessage: 'Paginate between results',
  },
  nextPage: {
    id: 'bo_sellers_customer_care_pagination_next_page_aria_label',
    defaultMessage: 'Next page',
  },
  previousPage: {
    id: 'bo_sellers_customer_care_pagination_previous_page_aria_label',
    defaultMessage: 'Previous page',
  },
  currentPage: {
    id: 'bo_sellers_customer_care_pagination_current_page_aria_label',
    defaultMessage: 'Page {page}',
  },
  tasksTechnicalIssueBlockTitle: {
    id: 'bo_sellers_customer_care_open_tasks_technical_issue_block_title',
    defaultMessage:
      'Tasks can’t currently be loaded due to a technical problem',
  },
  requestsTechnicalIssueBlockTitle: {
    id: 'bo_sellers_customer_care_all_requests_technical_issue_block_title',
    defaultMessage:
      'Requests can’t currently be loaded due to a technical problem',
  },
}
